module.exports = "/_next/static/images/ChatbotsDoughnut@2x-0394661ec8e32f47d61a572a5a432c03.webp";